import { render, staticRenderFns } from "./ImagesEdit.vue?vue&type=template&id=2bd2f8e2&scoped=true"
import script from "./ImagesEdit.vue?vue&type=script&lang=js"
export * from "./ImagesEdit.vue?vue&type=script&lang=js"
import style0 from "./ImagesEdit.vue?vue&type=style&index=0&id=2bd2f8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2f8e2",
  null
  
)

export default component.exports